import http from 'utils/http.js';

export const exportMoneyDebreifReport = (payload) => {
  return http.get(`/cash/cashMoney-Report-Star`, payload);
};
